import _ from 'lodash';
import moment from 'moment';
import { CreateEditTruckRouteScheduleEnum } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';

export const BASE_URL = '/truckroutes';

export const TIME_FORMAT_UI = 'hh:mm a';

const WEEK_DAYS = [
  { Id: 1, Description: 'Monday' },
  { Id: 2, Description: 'Tuesday' },
  { Id: 3, Description: 'Wednesday' },
  { Id: 4, Description: 'Thursday' },
  { Id: 5, Description: 'Friday' },
  { Id: 6, Description: 'Saturday' },
  { Id: 0, Description: 'Sunday' },
];

export const WEEK_DAY_OPTIONS = makeOptionsData(WEEK_DAYS);

export const getSaveObject = (id, values) => {
  const times = _.compact(
    values[CreateEditTruckRouteScheduleEnum.TruckRouteTimeComponent]
  );
  times.sort(function(a, b) {
    return new moment(a) - new moment(b);
  });
  return {
    id: id,
    description: values[CreateEditTruckRouteScheduleEnum.Description],
    routeIds: values[CreateEditTruckRouteScheduleEnum.TruckRouteScheduleGrid],
    dayOfWeek: _.sortBy(values[CreateEditTruckRouteScheduleEnum.DayOfWeek]),
    timeSlot: times,
  };
};

export const getDuplicateTimeSlots = timeSlotList => {
  return _.compact(
    timeSlotList.filter((item, index) => timeSlotList.indexOf(item) !== index)
  );
};

export const validateTruckScheduleData = values => {
  const errors = {};
  if (
    !values[CreateEditTruckRouteScheduleEnum.Description] ||
    !_.trim(values[CreateEditTruckRouteScheduleEnum.Description]).length
  ) {
    errors[CreateEditTruckRouteScheduleEnum.Description] =
      'Description is required! Please Enter a Description.';
  }
  if (
    !values[CreateEditTruckRouteScheduleEnum.DayOfWeek] ||
    !_.trim(values[CreateEditTruckRouteScheduleEnum.DayOfWeek]).length
  ) {
    errors[CreateEditTruckRouteScheduleEnum.DayOfWeek] =
      'Day selection is required! Please Select any Day.';
  }
  return errors;
};


// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/helper/index.js